import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { resources, type SupportedLanguage } from './resources'
import { agentSpecResources } from './agentSpecResources'
import { reasoningResources } from './reasoningResources'
import { agentJobResources } from './agentJobResources'
import { workResources } from './workResources'
import { orgResources } from './orgResources'
import { mcpToolsResources } from './mcpToolsResources'
import { settingsResources } from './settingsResources'

const supportedLanguages: SupportedLanguage[] = ['fr', 'en', 'es']
const storageKey = 'agent-maurice-os-language'

const resourcesWithAgentSpec = {
  ...resources,
  fr: {
    translation: {
      ...resources.fr.translation,
      agentSpec: agentSpecResources.fr,
      reasoning: reasoningResources.fr,
      agentJob: agentJobResources.fr,
      work: workResources.fr,
      org: orgResources.fr,
      mcpTools: mcpToolsResources.fr,
      settings: settingsResources.fr,
    },
  },
  en: {
    translation: {
      ...resources.en.translation,
      agentSpec: agentSpecResources.en,
      reasoning: reasoningResources.en,
      agentJob: agentJobResources.en,
      work: workResources.en,
      org: orgResources.en,
      mcpTools: mcpToolsResources.en,
      settings: settingsResources.en,
    },
  },
  es: {
    translation: {
      ...resources.es.translation,
      agentSpec: agentSpecResources.es,
      reasoning: reasoningResources.es,
      agentJob: agentJobResources.es,
      settings: settingsResources.es,
    },
  },
}

if (!i18n.isInitialized) {
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: resourcesWithAgentSpec,
      fallbackLng: 'fr',
      supportedLngs: supportedLanguages,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: storageKey,
        caches: ['localStorage'],
      },
    })

  i18n.on('languageChanged', (language) => {
    document.documentElement.lang = supportedLanguages.includes(language as SupportedLanguage)
      ? language
      : 'fr'
  })
}

export { supportedLanguages, storageKey }
export default i18n
